import React, { Component } from "react";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import FrontBanner from "@/assets/images/front-banner.svg";
import { withRouter } from "react-router-dom";
import api from "@/middlewares/api";
import moment from "moment";
import "./index.scss";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
} from "@material-ui/core";
import apiV2 from "@/middlewares/apiV2";
import { TopUpPanelContainer } from "./TopUpPanel";

class BillingHistoryPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rows: [],
      subscription: [],
      credits: [],
      planName: "Basic Plan",
      planAmount: "$0.00",
      cardLast4: "No Card Found",
      currentPage: 1,
      limit: 5, // Show 5 records per page
      lastPaymentId: null, // Used for pagination
      hasMore: false,
      loading: true,
    };
  }

  async componentDidMount() {
    this.setState({ loading: true });
    try {
      await Promise.all([
        this.fetchBillingDetails(false),
        this.fetchPaymentHistory("", "", false, false),
      ]);
    } catch (error) {
      console.error("Error during initial data fetch:", error);
    } finally {
      this.setState({ loading: false });
    }
  }

  fetchBillingDetails = async (setLoading = true) => {
    if (setLoading) this.setState({ loading: true });
    try {
      const response  = await api.get(`/billing/history`);
      if(response.data.subscription){
        this.setState({ subscription: response.data.subscription });
      }
      if(response.data.credits){
        this.setState({ credits: response.data.credits });
      }

      if (response.latestSubscription) {
        this.setState({
          planName:
            response?.latestSubscription.plan?.product_details?.name ||
            "Unknown Plan",
          planAmount: `$${(
            response.latestSubscription.items.data[0]?.plan.amount / 100
          ).toFixed(2)}`,
        });
      }

      if (response.paymentMethods.length > 0) {
        const last4 = response.paymentMethods[0].card.last4;
        this.setState({ cardLast4: `Visa Ending with ${last4}` });
      }
    } catch (error) {
      console.error("Error fetching billing details:", error);
    } finally {
      if (setLoading) this.setState({ loading: false });
    }
  };

  fetchPaymentHistory = async (
    starting_after = "",
    ending_before = "",
    clicking = false,
    setLoading = true
  ) => {
    if (setLoading) this.setState({ loading: true });
    try {
      const { currentPage } = this.state;
      const limit = 5;
      const url = `/payment-history?limit=${limit}${
        starting_after ? `&starting_after=${starting_after}` : ""
      }${ending_before ? `&ending_before=${ending_before}` : ""}`;

      const response = await apiV2.get(url);
      const data = response.data;

      if (data.paymentHistory) {
        this.setState({
          rows: data.paymentHistory,
          hasMore: data.hasMore,
          lastPaymentId: data.lastPaymentId, // For "Next" page
          firstPaymentId: data.firstPaymentId, // For the "Previous" page
        });
      }
      if (clicking) {
        if (!ending_before) {
          this.setState({
            currentPage: currentPage + 1,
          });
        } else if (!starting_after) {
          const newPage = Math.max(1, currentPage - 1);
          this.setState({
            currentPage: newPage,
            hasMore: true, // Reset hasMore when going back
          });
        }
      }
    } catch (error) {
      console.error("Error fetching billing details:", error);
    } finally {
      if (setLoading) this.setState({ loading: false });
    }
  };

  handleNextPage = () => {
    if (this.state.hasMore) {
      this.fetchPaymentHistory(this.state.lastPaymentId, "", true); // Move to next page
    }
  };

  handlePreviousPage = () => {
    if (this.state.firstPaymentId) {
      this.fetchPaymentHistory("", this.state.firstPaymentId, true); // Move to previous page
    }
  };

  handleBackClick = () => {
    this.props.history.push("/userdashboard/mysamples");
  };

  render() {
    return (
      <main className="page">
        <div className="main-section">
          <div className="content-section">
            <div className="product-header">
              <div
                className="back-to-home-section"
                onClick={this.handleBackClick}
              >
                <ArrowBackIcon />
              </div>
              <div className="back-to-home-section">
                <img src="https://ample-samples.s3.us-east-2.amazonaws.com/app/front-banner.svg" alt="Avatar" className="avatar" />
              </div>
            </div>
            <div className="back-to-home-section-image">
              <img src="https://ample-samples.s3.us-east-2.amazonaws.com/app/front-banner.svg" alt="front-banner" />
            </div>

            <div className="billing-main-wrapper">
              <div className="billing-cards-details">
                <div className="billing-cards-main-header">Billing</div>
                <div className="billing-cards">
                  <div className="plan-details">
                    <div className="plan-upgrade-wrapper">
                      <h3 className="plan-title">Your Plan</h3>
                      <button className="btn primary-btn upgrade-btn">
                        Upgrade Plan
                      </button>
                    </div>
                    <div className="plan-wrapper">
                     {this.state.subscription?.status === "active" ? <h5>{this.state.subscription.title}</h5> : ''}
                     {this.state.subscription?.status === "active" ? <p>${this.state.subscription.amount}</p> : ''}
                     {this.state.subscription?.status === "active" ? <p>Clearance Credits: {this.state.credits.sample_clearances}</p> : ''}
                     {this.state.subscription?.status === "active" ? <p>Started: {this.state.subscription.start} | Ends: {this.state.subscription.end}</p> : ''}
                    </div>
                    <TopUpPanelContainer />
                    <button className="upgrade-plan-sec">Upgrade Plan</button>
                  </div>
                  {/* <div className="card-details">
                    <div className="card-upgrade-wrapper">
                      <div className="card-title">Card Details</div>
                      <button className="btn primary-btn upgrade-btn">
                        Upgrade
                      </button>
                    </div>
                    <div className="card-number-wrapper">
                      <img src={visa} alt="card icon" className="card-icon" />
                      <p className="card-number">{cardLast4}</p>
                    </div>
                  </div> */}
                </div>
              </div>
              <div className="billing-history-wrapper">
                <h3 className="history-title">Billing History</h3>
                <div className="responsiveTableWrapper">
                  <TableContainer component={Paper} className="tableContainer">
                    <Table
                      className="table"
                      aria-label="responsive styled table"
                    >
                      <TableHead className="tableHead">
                        <TableRow>
                          <TableCell className="tableCellHeader">
                            DATE
                          </TableCell>
                          <TableCell className="tableCellHeader">
                            TYPE
                          </TableCell>
                          <TableCell className="tableCellHeader">
                            INVOICE URL
                          </TableCell>
                          <TableCell className="tableCellHeader">
                            INVOICE PDF
                          </TableCell>
                          <TableCell className="tableCellHeader">
                            AMOUNT
                          </TableCell>
                         
                        </TableRow>
                      </TableHead>
                      <TableBody className="tableBody">
                        {this.state.loading ? (
                          <TableRow>
                            <TableCell colSpan={5} align="center" className="tableCellBody">
                              <div className="loading-wrapper">
                                <CircularProgress size={30} color="inherit" />
                                <p>Loading payment history...</p>
                              </div>
                            </TableCell>
                          </TableRow>
                        ) : this.state.rows.length > 0 ? (
                          this.state.rows.map((row, index) => (
                            <TableRow key={index}>
                              <TableCell className="tableCellBody">
                                {row.purchased_at
                                  ? moment(row.purchased_at).format("MMM D, YYYY")
                                  : "-"}
                              </TableCell>
                              <TableCell className="tableCellBody">
                                {row.product_name || row.plan_name}
                              </TableCell>
                              <TableCell className="tableCellBody">
                                {row.invoice_url && (
                                  <a
                                    href={row.invoice_url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    View Invoice
                                  </a>
                                )}
                              </TableCell>
                              <TableCell className="tableCellBody">
                                {row.invoice_pdf && (
                                  <a
                                    href={row.invoice_pdf}
                                    download
                                    rel="noopener noreferrer"
                                  >
                                    Download PDF
                                  </a>
                                )}
                              </TableCell>
                              <TableCell
                                className={`tableCellBody ${
                                  row.amount < 0 ? "negativeAmount" : ""
                                }`}
                              >
                                {row.amount}
                              </TableCell>
                            </TableRow>
                          ))
                        ) : (
                          <TableRow>
                            <TableCell colSpan={5} align="center" className="tableCellBody">
                              <div className="empty-state-wrapper">
                                <p>No payment history records found.</p>
                              </div>
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <div className="pagination-controls">
                    {/* <button
                      className="btn primary-btn pagination-button"
                      disabled={currentPage === 1}
                      onClick={() =>
                        this.fetchPaymentHistory(undefined, rows[0]?.id, true)
                      }
                    >
                      Previous
                    </button> 

                  <button
                      className="btn primary-btn pagination-button"
                      disabled={!hasMore}
                      onClick={() =>
                        this.fetchPaymentHistory(
                          rows[rows?.length - 1]?.id,
                          undefined,
                          true
                        )
                      }
                    >
                      Next
                    </button> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    );
  }
}

export default withRouter(BillingHistoryPage);
